<template>
  <div class="cont_section">
    <div class="confirm-box">
      <p class="confirm-box-message type-a">
        <i class="sp_order" />신청이 완료되었습니다.
      </p>
    </div>

    <ol class="mypack_step">
      <li class="finish">
        <i class="step01" />
        <p>마이팩 신청</p>
      </li>
      <li :class="{'active' : !isConsulted}">
        <i class="step02" />
        <p>채팅 또는 ABC 상담</p>
      </li>
      <li :class="{'active' : isConsulted}">
        <i class="step03" />
        <p>결제 및 수령</p>
      </li>
      <li>
        <i class="step04" />
        <p>간편 재주문</p>
      </li>
    </ol>

    <div class="text_box type_blue" v-if="isVcall && !isConsulted">
      <div class="text_box_inner">
        <div class="text_box_tit">채팅 상담 후 배달 수령 선택하신 경우</div>
        <p>
          <span
            ><em
              >카카오톡 알림톡을 통해 채팅 상담 URL이 발송될 예정입니다.<br />결제와
              제품 수령을 위해 채팅 상담을 진행해 주세요.</em
            ></span
          >
        </p>
      </div>
    </div>

    <div class="text_box type_red" v-if="isAbc && !isConsulted">
      <div class="text_box_inner">
        <div class="text_box_tit">ABC 방문수령 선택하신 경우</div>
        <p>
          <span
            ><em>결제와 제품 수령을 위해 {{ centerLocation }} ABC 마이팩 랩</em
            >을</span
          >
          방문해 주세요.
        </p>
        <ul>
          <li>
            * 마이팩 랩에서 담당 직원 상담 완료 후 신청하신 마이팩을 구매하실 수
            있습니다.
          </li>
          <li>
            * 마이팩 랩에서 회원번호화 성함을 말씀하시면 확인을 받으실 수
            있습니다.
          </li>
        </ul>
      </div>
    </div>
    <!-- E : info text box -->

    <!-- ABC 위치 안내 링크로 새페이지 창 처리? -->
    <div class="right_btn" v-if="isAbc">
      <button type="button" data-layer="abc-info-layer" @click="onClickAbcInfo">
        ABC 안내
      </button>
    </div>
  </div>
</template>

<script>
import { openNewWindow } from "@/utils/common";
import { PACK_STATUS_CODE } from "@/utils/constants";

export default {
  name: "CompleteCommonInfo",
  components: {},
  props: {
    centerLocation: {
      type: String,
      default: "",
    },
    cfmKind: {
      type: String,
      default: "ABC",
    },
    packStatus: {
      type: String,
      default: "",
    },
  },
  computed: {
    isVcall() {
      return this.cfmKind === "VCALL";
    },
    isAbc() {
      return this.cfmKind === "ABC";
    },
    isConsulted() {
      return this.packStatus == PACK_STATUS_CODE.CONSULTATION_FINISHED;
    },
  },
  methods: {
    onClickAbcInfo() {
      openNewWindow(
        `https://${process.env.SSO_HOST}/store-finder`,
        "store-finder"
      );
    },
    onReservationInfo() {
      this.$emit("on-reservation-info");
    },
  },
};
</script>
